(function($){
    'use strict';

    $('.js-themes button').click(function() {
    	var $theme = $(this).closest('li');

    	if(!$theme.hasClass('active')) {
    		var $currentTheme = $('.js-themes li.active');

    		$('.main').removeClass($currentTheme.attr('data-theme')).addClass($theme.attr('data-theme'));
    		$currentTheme.removeClass('active');
    		$theme.addClass('active');
    	}	
    	
    });
    
}(jQuery));